import { useState } from "react";
import { can } from "@/lib/rbac";
import SecurityAlerts from "@/components/admin/SecurityAlerts";
import UserTable from "@/components/admin/UserTable";
import UserFormDialog from "@/components/admin/UserFormDialog";
import RolePermissions from "@/components/admin/RolePermissions";
import LoginActivity from "@/components/admin/LoginActivity";
import BackupPanel from "@/components/admin/BackupPanel";
import DangerZone from "@/components/admin/DangerZone";

// Users tab: account CRUD, role matrix and (admin-only) security, login activity, backups and data tools.
export default function UserManagement({ users, machines = [], currentUser, onCreate, onUpdate, onDelete, onClearData, onSeedDemo, onImported, lockoutTick, onLockoutChange }) {
  const isAdmin = can.manageUsers(currentUser.role);
  const [formUser, setFormUser] = useState(undefined); // undefined = closed, null = add, object = edit
  const [activityKey, setActivityKey] = useState(0);
  const onAlertsChanged = () => { onLockoutChange?.(); setActivityKey((k) => k + 1); };
  const submitUser = (patch, user) => (user ? onUpdate(user, patch) : onCreate(patch));

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
      {isAdmin && <SecurityAlerts lockoutTick={lockoutTick} onChanged={onAlertsChanged} />}
      <UserTable users={users} machines={machines} currentUser={currentUser} isAdmin={isAdmin} onAdd={() => setFormUser(null)} onEdit={setFormUser}
        onToggleActive={(u, active) => onUpdate(u, { active })} onDelete={onDelete} onImported={onImported} />
      <RolePermissions />
      {isAdmin && <LoginActivity users={users} refreshKey={activityKey} />}
      {isAdmin && <BackupPanel onRestored={onImported} />}
      {isAdmin && <DangerZone onClearData={onClearData} onSeedDemo={onSeedDemo} onImported={onImported} />}
      <UserFormDialog open={formUser !== undefined} user={formUser || null} currentUser={currentUser} machines={machines} onOpenChange={(v) => !v && setFormUser(undefined)} onSubmit={submitUser} />
    </div>
  );
}
